import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from '../../axios/axiosconf';
import SuperadminSidebar from './SuperadminSidebar';
import './SuperadminStyles.css';

const SuperadminLayout = ({ children }) => {
    const history = useHistory();
    const [superadminUser, setSuperadminUser] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');

        if (!token || !user) {
            history.push('/superadmin/login');
            return;
        }

        setSuperadminUser(JSON.parse(user));
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }, [history]);

    const handleLogout = async () => {
        try {
            await axios.post('/superadmin/logout');
        } catch (error) {
            console.error('Error during logout:', error);
        } finally {
            localStorage.removeItem('superadmin_token');
            localStorage.removeItem('superadmin_user');
            delete axios.defaults.headers.common['Authorization'];
            history.push('/superadmin/login');
        }
    };

    return (
        <div className="superadmin-dashboard">
            <header className="superadmin-navbar">
                <div className="superadmin-navbar__brand">
                    <h3>
                        <i className="fas fa-user-shield"></i>
                        <span className="superadmin-navbar__title"> Panel Superadmin</span>
                    </h3>
                    <small className="superadmin-navbar__welcome">
                        Bienvenido, {superadminUser?.nombre}
                    </small>
                </div>
                <button type="button" className="btn btn-light btn-sm superadmin-navbar__logout" onClick={handleLogout}>
                    <i className="fas fa-sign-out-alt"></i>
                    <span className="superadmin-navbar__logout-text"> Cerrar Sesión</span>
                </button>
            </header>

            <div className="superadmin-body">
                <aside className="superadmin-sidebar-col">
                    <SuperadminSidebar />
                </aside>
                <main className="superadmin-main">
                    <div className="superadmin-content">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default SuperadminLayout;
